import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import CustomSelect from "../../components/customFields/customSelect";

import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';

import GeneralForm from "../../components/generalForm";
import {connect} from "react-redux";
import CTA_TYPE from "../../components/constants/ctaType";
import AutoResizeTextarea from "../../components/customFields/autoResizeTextarea";
import icon from "../../assets/icons/form-marketplace.svg";

const CtaForm = ({match, action, intl, history}) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cta, setCta] = useState({});
  const [image, setImage] = useState(null);

  useEffect(() => {
    if (action === 'edit') {
      setError(null);
      setLoading(true);
      apiCalls.getCtas({
        ctaId: match.params.ctaId,
      })
        .then((result) => {
          setCta(getCtaForForm(result.data.ctas[0]));
          setImage(result.data.ctas[0].image);
          setLoading(false);
        })
        .catch((errors) => {
          setError(utils.getErrorMessageFromResponse(errors));
          setLoading(false);
        });
    }
  }, [match.params.ctaId]);
  
  const ctaTypes = Object.keys(CTA_TYPE).map((key) => {
    const type = CTA_TYPE[key];
    return {
      value: type,
      label: intl.formatMessage({id:'cta.form.field.type.name.' + type}),
    };
  });

  const tabIndexOptions = [
    {
      value: 0,
      label: 'First tab',
    },
    {
      value: 1,
      label: 'Second tab',
    },
    {
      value: 2,
      label: 'Third tab',
    },
  ];

  const formSchema = {
    type: "object",
    required: [],
    properties: {
      type: {
        type: "string",
        title: intl.formatMessage({id: 'cta.form.field.type.label'}),
        options: ctaTypes,
      },
      title: {
        type: "string",
        title: intl.formatMessage({id: 'cta.form.field.title.label'}),
      },
      description: {
        type: "string",
        title: intl.formatMessage({id: 'cta.form.field.description.label'}),
        default: ''
      },
      url: {
        type: "string",
        title: intl.formatMessage({id: 'cta.form.field.url.label'}),
      },
      idArgument: {
        type: "number",
        title: intl.formatMessage({id: 'cta.form.field.id.argument.label'}),
        default: null,
      },
      marketplaceId: {
        type: "string",
        title: intl.formatMessage({id: 'cta.form.field.marketplace.id.label'}),
      },
      marketplaceCategory: {
        type: "string",
        title: intl.formatMessage({id: 'cta.form.field.marketplace.category.label'}),
      },
      itemId: {
        type: "string",
        title: intl.formatMessage({id: 'cta.form.field.item.id.label'}),
      },
      tabIndex: {
        options: tabIndexOptions,
        type: "number",
        title: intl.formatMessage({id: 'cta.form.field.tab.index.label'}),
      },
    }
  };

  const uiSchema = {
    description: {
      "ui:field": "autoResizeTextarea"
    },
    type: {
      "ui:field": "customSelect",
    },
    url: {
      "ui:help": intl.formatMessage({id: 'cta.form.field.url.help'}),
    },
    tabIndex: {
      "ui:field": "customSelect",
      "ui:help": intl.formatMessage({id: 'cta.form.field.tab.index.help'}),
    },
  };

  function onFormSubmit() {
    setLoading(true);

    if (action === 'edit') {
      return apiCalls.editCta({cta, image})
        .then((result) => {
          setLoading(false);
          history.push({
            pathname: '/admin/ctas'
          });
        })
        .catch((error) => {
          setLoading(false);
          setError(utils.getErrorMessageFromResponse(error, true));
          window.scrollTo(0, 0);
        });
    } else {
      return apiCalls.createCta({cta, image})
        .then((result) => {
          setLoading(false);
          history.push({
            pathname: '/admin/ctas'
          });
        })
        .catch((error) => {
          setLoading(false);
          setError(utils.getErrorMessageFromResponse(error, true));
          window.scrollTo(0, 0);
        });
    }
  }

  const buttonCopy = action === 'edit' ? 'cta.edit.form.submit' : 'cta.create.form.submit';

  const formFields = {
    customSelect: CustomSelect,
    autoResizeTextarea: AutoResizeTextarea,
  };

  const header = action === 'edit' && !loading ?
    intl.formatMessage({id: 'cta.edit.header'}, {ctaTitle: cta.title}):
    intl.formatMessage({id: 'cta.create.header'});

  return (
    <div className="row">
      <div className="col-12 col-lg-10 offset-lg-1 admin__form">
        <GeneralForm title={header}
                     icon={icon}
                     onChange={(event) => setCta(event.formData)}
                     onSubmit={onFormSubmit}
                     uploadImage={(image) => apiCalls.uploadImage(image, 'cta', cta.id)}
                     deleteImage={(image) => apiCalls.deleteImage(image)}
                     onImagesChange={(images) => setImage(images[0])}

                     formSchema={formSchema}
                     formUiSchema={uiSchema}
                     formFields={formFields}

                     formData={cta}
                     uploadedImages={image? [image]: []}

                     buttonCopy={buttonCopy}
                     errorMessage={error}
                     loading={loading}
                     singleImage={true}
        />
      </div>
    </div>
  );
}

function getCtaForForm(cta) {
  const itemId = cta.item? cta.item.id: null;
  const marketplaceId = cta.marketplace? cta.marketplace.id: null;
  const result = Object.assign({}, cta);
  result.itemId = itemId;
  result.marketplaceId = marketplaceId;
  return result;
}

CtaForm.propTypes = {
  currentUser: PropTypes.object,
  action: PropTypes.string.isRequired,
};

CtaForm.defaultProps = {
  action: 'create',
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default injectIntl(connect(mapStateToProps)(CtaForm));